// extracted by mini-css-extract-plugin
export var gif = "_ch-0";